import httpClient from 'utils/httpClient.js';
import { withPortalScope } from 'utils/portalScope';

export const getListReport = (params = {}) => {
  return httpClient.get('/report', { params: withPortalScope(params) });
};

export const exportExcel = (params = {}) => {
  const header = {
    responseType: `blob`,
  };
  return httpClient.get('/report/export', { params: withPortalScope(params), ...header });
};

export const getListReportAccounting = (params = {}) => {
  return httpClient.get('/report/accounting', { params: withPortalScope(params) });
};

const withAccountingReportScope = (params = {}) => {
  const scoped = withPortalScope(params);
  for (const dimension of ['company', 'business', 'store']) {
    const singleKey = `${dimension}_id`;
    const multipleKey = `${dimension}_ids`;
    if (Object.prototype.hasOwnProperty.call(params, multipleKey)) {
      scoped[singleKey] = '';
      scoped[multipleKey] = params[multipleKey] ?? '';
    } else if (Object.prototype.hasOwnProperty.call(params, singleKey)) {
      // Chuỗi rỗng được gửi qua HTTP để giữ thao tác bỏ lọc của người dùng.
      scoped[singleKey] = params[singleKey] ?? '';
    }
  }
  return scoped;
};

export const getAccountingReport = (reportCode, params = {}) => {
  return httpClient.get(`/report/accounting-report/${reportCode}`, { params: withAccountingReportScope(params) });
};

export const getBankReportOptions = (reportCode, params = {}) =>
  httpClient.get(`/report/accounting-report/${reportCode}/options`, { params: withAccountingReportScope(params) });

export const exportAccountingReportPdf = (reportCode, params = {}) =>
  httpClient.get(`/report/accounting-report/${reportCode}/export-pdf`, { params: withAccountingReportScope(params) });

export const getFinancialReportMapping = (reportCode) =>
  httpClient.get(`/report/financial-mapping/${reportCode}`);

export const saveFinancialReportMapping = (reportCode, body) =>
  httpClient.put(`/report/financial-mapping/${reportCode}`, body);

export const exportReportAccounting = (params = {}) => {
  const header = {
    responseType: `blob`,
  };
  return httpClient.get('/report/export-accounting', { params: withPortalScope(params), ...header });
};
